<template>
  <page-frame bodyStyle="bottom:1.78rem;" footStyle="height:1.78rem;">
    <div class="foot" slot="foot">
      <botton-bar></botton-bar>
    </div>

    <div class="user-main">
      <div style="width: 1.064rem; height: 1.064rem; position: absolute; bottom: 0;z-index: 666;" @click="doubleTaps"></div>
      <label for="uploadFile">
        <img class="avatar" :src="src" />
        <input type="file" style="display:none" id="uploadFile" name="uploadFile" accept="image/png,image/jpeg,image/gif,image/jpg" @change="uploadImg($event, 1)" />
      </label>
      <div class="user-name">
        <span style="display:inline-block;width:2rem;vertical-align:middle;" class="ellipsis" v-if="TicketID">{{ UserName }}</span>
        <span v-else>{{ $t("mall.PleaseLogIn") }}</span>
        <!-- <span class="user-edit" @click="ToEditProfile()">
          <span>{{ $t("mall.EditData") }}</span>
          <img src="/static/img/left2.png" />
        </span> -->
      </div>
      <img class="setting" @click="ToAccount" src="/static/img/setting.png" />
    </div>
    <div class="user-navBar">
      <router-link tag="div" to="/order/list?filterCode=allorder">
        <img src="/static/img/allOrder.png" />
        <div>{{ $t("system.AllOrders") }}</div>
      </router-link>
      <router-link tag="div" to="/order/list?filterCode=waitapproval">
        <img src="/static/img/ToReview.png" />
        <div>{{ $t("system.ApprovalDispose") }}</div>
      </router-link>
      <!-- <router-link tag="div" :to="'/order/list?BusinessStatus=10107' + '&title=' + $t('system.Obligation')"> -->
      <router-link tag="div" to="/order/list?filterCode=recenttrip">
        <img src="/static/img/obligation.png" />
        <div>{{ $t("system.RecentOrders") }}</div>
      </router-link>
      <!-- <router-link tag="div" :to="'/order/list?TaskDate=' + TaskDate + '&BusinessStatus=10113' + '&title=' + $t('system.NotToTravel')"> -->
      <router-link tag="div" to="/order/list?filterCode=myorder">
        <img src="/static/img/NotToTravel.png" />
        <div>{{ $t("system.MyOrder") }}</div>
      </router-link>
    </div>
    <div class="user-wrapper">
      <!-- <div class="user-item">
        <router-link tag="div" to="/system/user/account">
          <img class="setting" src="/static/img/setting.png" />
          <span>{{ $t("我的账户") }}</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div> -->
      <div class="user-item">
        <router-link tag="div" to="/system/oftenPassenger">
          <img src="/static/img/card1.png" style="width:0.665rem" />
          <span>{{ $t("system.ThePassengerInformation") }}</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div>
      <div class="user-item">
        <router-link tag="div" to="/system/invoice">
          <img src="/static/img/invoice.png" style="width:0.665rem" />
          <span>{{ $t("system.TicketInformation") }}</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div>
      <div class="user-item">
        <router-link tag="div" to="/system/address">
          <img src="/static/img/concat1.png" style="width:0.532rem" />
          <span>{{ $t("system.contacts") }}</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div>
      <div class="user-item" v-if="isShowApprovalAuthorize">
        <router-link tag="div" to="/system/approvalSet/list">
          <img src="/static/img/approvalSet.png" style="width:0.585rem" />
          <span>{{ $t("system.ApprovalAccredit") }}</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div>
      <div class="user-item">
        <router-link tag="div" to="/system/configInfo">
          <img src="/static/img/pzgl.png" style="width:0.665rem" />
          <span>{{ $t("system_user_main_peizhiguanli") }}</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div>
      <div class="user-item">
        <router-link tag="div" to="/system/about">
          <img src="/static/img/about.png" style="width:0.665rem" />
          <span>{{ $t("system.AboutUs") }}</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div>
      <div class="user-item">
        <router-link tag="div" to="/system/servicePolicy">
          <img src="/static/img/about.png" style="width:0.665rem" />
          <span>{{ $t("login_fuwuxieyi").replace(/《|》/gi, "") }}</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div>
      <div class="user-item">
        <router-link tag="div" to="/system/privacySettings">
          <img src="/static/img/about.png" style="width:0.665rem" />
          <span>隐私设置</span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div>
      <!-- <div class="user-item">
        <router-link tag="div" to="/system/privacyPolicy">
          <img src="/static/img/about.png" style="width:0.665rem" />
          <span>{{ $t("login_yinsizhengce").replace(/《|》/gi, "") }} </span>
          <div class="left"><img src="/static/img/left.png" style="width:0.425rem" /></div>
        </router-link>
      </div> -->
    </div>
    <div v-if="show" class="wrappers">
      <VueCropper
        ref="cropper"
        :img="option.img"
        :outputSize="option.size"
        :outputType="option.outputType"
        :info="false"
        :full="option.full"
        :canMove="option.canMove"
        :canMoveBox="option.canMoveBox"
        :fixedBox="option.fixedBox"
        :original="option.original"
        :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight"
        :autoCrop="option.autoCrop"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
        @realTime="realTime"
        :enlarge="option.enlarge"
      ></VueCropper>
      <div class="btn">
        <a @click="cancel">{{ $t("share.cancelTxt") }}</a>
        <a @click="finish('base64')">{{ $t("share.confirmTxt") }}</a>
      </div>
    </div>
  </page-frame>
</template>
<style lang="less" scoped>
  .avatar {
    height: 1.86rem;
    width: 1.86rem;
    display: inline-block;
    margin-top: 0.798rem;
    border-radius: 50%;
  }

  .appInner .user-main {
    padding-top: 0.53rem;
  }

  .appInner .message,
  .appInner .setting {
    top: 2.66rem;
  }

  .iphoneX .user-main {
    padding-top: 2.66rem;
  }

  .iphoneX .message {
    top: 1.596rem;
  }

  .iphoneX .setting {
    top: 1.596rem;
  }

  .user-main {
    // background-image: url("/static/img/userBg.png");
    height: 4.783rem;
    padding-top: 1.06rem;
    box-sizing: border-box;
    // background-repeat: no-repeat;
    text-align: center;
    color: #fff;
    position: relative;
    font-size: 0.478rem;
    // background-size: 100% 100%;
    background: linear-gradient(to right, #4bd3ff, #3091ff);
  }

  .user-name {
    position: relative;
  }

  .user-edit {
    position: absolute;
    bottom: 0;
    right: 0.27rem;
    font-size: 0.372rem;
  }

  .user-edit span {
    vertical-align: middle;
  }

  .user-edit img {
    vertical-align: middle;
    width: 0.319rem;
    transform: rotateY(180deg);
  }

  .message,
  .setting {
    position: absolute;
    left: 0.27rem;
    top: 1.592rem;
    width: 0.66rem;
  }
  .setting {
    left: auto;
    right: 0.266rem;
  }

  .user-navBar {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    font-size: 0.302rem;
    padding: 0.665rem;
  }

  .user-navBar img {
    width: 1.2rem;
  }

  .user-item {
    position: relative;
    margin-bottom: 0.266rem;
    padding-left: 0.266rem;
    height: 1.596rem;
    line-height: 1.596rem;
    color: #323232;
    margin-top: 0.266rem;
    background-color: #fff;
    text-align: left;
  }

  .user-item img {
    vertical-align: middle;
  }

  .user-item span {
    vertical-align: middle;
    margin-left: 0.266rem;
    font-size: 0.425rem;
  }

  .left {
    position: absolute;
    right: 0.266rem;
    bottom: 0;
  }
</style>
<style scoped>
  .box {
    position: relative;
    height: 100%;
  }

  .wrappers {
    position: fixed;
    width: 100%;
    top: 0;
    height: calc(100% - 50px);
    z-index: 100;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .vue-cropper {
    background: black;
    background-image: none !important;
  }

  .btn {
    height: 50px;
    background: #565656;
    padding: 0 15px;
  }

  .btn a {
    color: white;
    font-size: 0.425rem;
    display: inline-block;
    line-height: 50px;
  }

  .btn a:nth-of-type(1) {
    float: left;
  }

  .btn a:nth-of-type(2) {
    float: right;
  }
</style>
<script>
  import VueCropper from "./modules/vue-cropper.vue";
  import menus from "../modules/menus.vue";
  import { categoryMap, Categorys, RoleType } from "@/model/Base";
  import UserService from "@/service/UserService";

  function getImgs(path, type) {
    let reg = /^app./g;
    let hostname = window.location.hostname;
    if (!reg.test(hostname) || hostname == "app.ecs.net") {
      hostname = "app.lchtrip.com";
    }
    if (!type || type == "img") {
      return `/static/${hostname.replace(/\./g, "")}/imgs/${path}`;
    } else {
      return `url(/static/${hostname.replace(/\./g, "")}/imgs/${path})`;
    }
  }

  export default {
    name: "allOrder",
    data() {
      return {
        TaskDate: moment().format("YYYY-MM-DD HH:mm"),
        model: {},
        previews: {},
        src: getImgs("avatar.png"),
        option: {
          img: "", //裁切图片的地址
          outputSize: 0.5, //裁剪生成图片的质量 0.1-1
          full: false, //是否输出原图比例的截图
          outputType: "png", //裁剪生成图片的格式
          fixedBox: true, //固定截图框大小 不允许改变
          original: false, //上传图片按照原始比例渲染
          canMoveBox: true, //截图框能否拖动
          canMove: true, // 上传图片是否可以移动
          autoCrop: true, //是否默认生成截图框
          fixed: true,
          autoCropWidth: 200,
          autoCropHeight: 200,
          fixedNumber: [1, 1],
          maxImgSize: 200,
          enlarge: 1.1,
          // mode: 'cover'
        },
        show: false,
        ContactList: {},
        isShowApprovalAuthorize: true,
      };
    },
    computed: {
      UserName() {
        return this.profile && this.profile.UserName;
      },
      UserID() {
        return this.profile && this.profile.UserID;
      },
      SpaceID() {
        return this.UserID;
      },
      TicketID() {
        return this.profile && this.profile.TicketID;
      },
      systemVersion() {
        return this.$route.query.systemVersion;
      },
      origin() {
        return this.$route.query.location;
      },
    },
    created() {
      let __self = this;
      let explain = $(".explain-image");
      let imageContainer = $(".g-core-image-corp-container");
      if (imageContainer) {
        explain.append(imageContainer);
      }
      if (window.localStorage.RoleInfo) {
        var storageInfo = JSON.parse(window.localStorage.RoleInfo);
        if (storageInfo.RoleIcon && storageInfo.RoleIcon != "") {
          __self.src = storageInfo.RoleIcon;
        }
      }
    },
    mounted() {
      let __self = this;
      __self.getContactList();
      __self.getCompanyConfigs();
    },
    methods: {
      getContactList() {
        let __self = this;
        let data = {
          RoleID: __self.UserID,
        };
        UserService.getContactList(data).then(function(json) {
          if (json.isSucc) {
            let result = _.find(json.result.entities, o => {
              return o.IsDefault == 1150;
            });
            if (result) {
              __self.ContactList = result;
            }
          }
        });
      },
      getCompanyConfigs() {
        let __self = this;
        UserService.getCompanyConfigs().then(json => {
          if (!json.isSucc || !json.result) {
            return;
          }
          let hideApproval = _.find(json.result, n => n.ConfigCode == "Btrip.Hide.Approval.Authorize" && n.ConfigValue == "1150");
          console.log(hideApproval);
          if (hideApproval) {
            __self.isShowApprovalAuthorize = false;
          } else {
            __self.isShowApprovalAuthorize = true;
          }
        });
      },

      isWeiXin() {
        let __self = this;
        let userAgent = window.navigator.userAgent;
        if (userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
          return true;
        } else {
          return false;
        }
      },
      doubleTaps() {
        alert(location.href);
        alert(window.lch_device_info);
        if (window.lch_device_info) {
          alert(window.lch_device_info.statusBarHeight);
        }
      },
      __init() {
        let __self = this;
        let data = {
          RoleID: __self.UserID,
        };
        UserService.getRoleInfo(data).then(function(json) {
          if (json.isSucc) {
            window.localStorage.RoleInfo = JSON.stringify(json.result);
          }
        });
      },
      finish(type) {
        let __self = this;
        if (type === "blob") {
          __self.$refs.cropper.getCropBlob(o => {
            let img = window.URL.createObjectURL(o);
            __self.src = img;
            __self.show = false;
          });
        } else {
          __self.$refs.cropper.getCropData(o => {
            console.log(o);
            __self.SaveImg(o);
          });
        }
      },
      cancel() {
        let __self = this;
        __self.show = false;
      },
      realTime(data) {
        this.previews = data;
      },
      ToAccount() {
        let __self = this;
        __self.$router.push({
          path: "/system/user/account",
        });
      },
      // ToEditProfile() {
      //   let __self = this;
      //   __self.$router.push({
      //     path: "/system/user/editProfile",
      //     query: {
      //       ContactID: __self.ContactList.ContactID,
      //     },
      //   });
      // },
      IsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      uploadImg(e, num) {
        let __self = this;
        // if (__self.IsPC()) {
        //   window.uploadAvatar = function (base64Url) {
        //     // __self.SaveImg(base64Url)
        //   };
        //   return
        // }
        let file = e.target.files[0];
        if (!e.target.files.length) {
          return;
        }
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          __self.option.img = e.target.result;
          __self.show = true;
        };
      },
      SaveImg(o) {
        let __self = this;
        __self.$api.storage.getUploadImg(o, moment().format("X"), "base64").then(function(json) {
          let result = json.data;
          if (window.localStorage.RoleInfo) {
            __self.model = JSON.parse(window.localStorage.RoleInfo);
          }
          let Superior = __self.model.Superior;
          if (Superior.RoleID == null || Superior.RoleID == undefined || Superior.RoleID == "") {
            Superior.RoleID = __self.SpaceID;
          }
          __self.model.RoleIcon = result;
          Superior.RoleType = RoleType.User;
          Superior.RootID = __self.SpaceID;
          __self.show = false;
          __self.src = o;
          UserService.saveRoleInfo(__self.model).then(json => {
            if (json.isSucc) {
              __self.__init();
              this.$root.$toast.success(json.data.message);
            }
          });
        });
      },
    },
    components: {
      menus,
      VueCropper,
    },
  };
</script>
